export const UPDATE_MIS_TEAM = 'Update_Mis_Team';
export const UPDATE_MIS_TEAM_SUCCESS = 'Update_Mis_Team_Success';
export const UPDATE_MIS_TEAM_FAILURE = 'Update_Mis_Team_Failure';

export const updateMisTeam = (data) => {
    return {
        type: UPDATE_MIS_TEAM,
        data
    }
}
export const updateMisTeamSuccess = (data) => {
    return {
        type: UPDATE_MIS_TEAM_SUCCESS,
        data
    }
}
export const updateMisTeamFailure = (data) => {
    return {
        type: UPDATE_MIS_TEAM_FAILURE,
        data
    }
}

export const MIS_TEAM_LIST="MIS_Team_List";
export const MIS_TEAM_LIST_SUCCESS="MIS_Team_Success";
export const MIS_TEAM_LIST_FAILURE="MIS_Team_Failure";

export const getMisTeam = (data) => {
    return {
        type: MIS_TEAM_LIST,
        data
    }
}
export const getMisTeamSuccess = (data) => {
    return {
        type: MIS_TEAM_LIST_SUCCESS,
        data
    }
}
export const getMisTeamFailure = (data) => {
    return {
        type: MIS_TEAM_LIST_FAILURE,
        data
    }
}


export const FETCH_MIS_TEAM_BY_ID="Fetch_MIS_Team_By_Id";
export const FETCH_MIS_TEAM_BY_ID_SUCCESS="Fetch_MIS_Team_By_Id_Success";
export const FETCH_MIS_TEAM_BY_ID_FAILURE="Fetch_MIS_Team_By_Id_Failure";

export const fetchMisTeamById = (data) => {
    return {
        type: FETCH_MIS_TEAM_BY_ID,
        data
    }
}
export const fetchMisTeamByIdSuccess = (data) => {
    return {
        type: FETCH_MIS_TEAM_BY_ID_SUCCESS,
        data
    }
}
export const fetchMisTeamByIdFailure = (data) => {
    return {
        type: FETCH_MIS_TEAM_BY_ID_FAILURE,
        data
    }
}

export const FETCH_MIS_FIELDS = 'src/Admin/Mis-Team/action/Fetch_Mis_Fields';
export const FETCH_MIS_FIELDS_SUCCESS = 'src/Admin/Mis-Team/action/Fetch_Mis_Fields_Success';
export const FETCH_MIS_FIELDS_FAILURE = 'src/Admin/Mis-Team/action/Fetch_Mis_Fields_Failure';

export const fetchMisFields = (data) => {
    return {
        type: FETCH_MIS_FIELDS,
        data
    }
}
export const fetchMisFieldsSuccess = (data) => {
    return {
        type: FETCH_MIS_FIELDS_SUCCESS,
        data
    }
}
export const fetchMisFieldsFailure = (error) => {
    return {
        type: FETCH_MIS_FIELDS_FAILURE,
        error
    }
}


export const FETCH_DEFAULT_MIS_FIELDS = 'src/Admin/Corporate/Mis-Team/Fetch_Default_Mis_Fields';
export const FETCH_DEFAULT_MIS_FIELDS_SUCCESS = 'src/Admin/Corporate/Mis-Team/Fetch_Default_Mis_Fields_Success';
export const FETCH_DEFAULT_MIS_FIELDS_FAILURE = 'src/Admin/Corporate/Mis-Team/Fetch_Default_Mis_Fields_Failure';
export const fetchDefaultMisFields = (data) => {
    return {
        type: FETCH_DEFAULT_MIS_FIELDS,
        data
    }
}
export const fetchDefaultMisFieldsSuccess = (data) => {
    return {
        type: FETCH_DEFAULT_MIS_FIELDS_SUCCESS,
        data
    }
}
export const fetchDefaultMisFieldsFailure = (error) => {
    return {
        type: FETCH_DEFAULT_MIS_FIELDS_FAILURE,
        error
    }
}
